namespace GeniuzPOS.InitialData {
    export class PsCashCouponTypeColumns {
        static columnsKey = 'InitialData.PsCashCouponType';
    }
}
